










import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'FloatingField',
})
export default class FloatingField extends Vue {
    @Prop({ type: String, required: true }) readonly label!: string
    @Prop({ required: true }) readonly value!: any

    get hasValue() {
        return Boolean(this.value) || this.value === 0;
    }
}
